export default "__VITE_ASSET__d958e748__"